import PropTypes from 'prop-types';
import { Trans, useTranslation } from 'react-i18next';
import Alert from 'Components/Molecules/Alert/Alert';
import Button from 'Components/Atoms/Button/Button';

export default function PendingInvitationAlert(props) {
    const { invitation, onCheck, className, stacked } = props;
    const { t } = useTranslation('common');

    return (
        <Alert
            title={t('invitation-pending')}
            className={className}
            stacked={stacked}
            classNameIcon="bg-[#ECE9F9]"
            icon={
                <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" fill="none" viewBox="0 0 28 28">
                    <path
                        stroke="#4021C8"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M20.667 10c0-.733-.6-1.333-1.334-1.333H8.667c-.734 0-1.334.6-1.334 1.333m13.334 0v8c0 .733-.6 1.333-1.334 1.333H8.667c-.734 0-1.334-.6-1.334-1.333v-8m13.334 0L14 14.667 7.333 10"
                    ></path>
                </svg>
            }
            description={
                <Trans t={t} i18nKey="invitation-pending-description">
                    {{ name: invitation.name }}
                </Trans>
            }
            actions={[
                <Button variant="primary" onClick={onCheck} key="accept">
                    {t('invitation-check')}
                </Button>,
            ]}
        />
    );
}

PendingInvitationAlert.propTypes = {
    invitation: PropTypes.shape({
        name: PropTypes.string.isRequired,
    }).isRequired,
    onCheck: PropTypes.func.isRequired,
    className: PropTypes.string,
    stacked: PropTypes.bool,
};
